export const STATUS_OPTIONS = [
  { value: 'new', label: 'New', tone: 'blue' },
  { value: 'in_progress', label: 'In progress', tone: 'green' },
  { value: 'waiting', label: 'Waiting', tone: 'amber' },
  { value: 'closed', label: 'Closed', tone: 'neutral' }
]

export const WAITING_OPTIONS = [
  { value: 'requester', label: 'Requester' },
  { value: 'internal_team', label: 'Internal team' },
  { value: 'external_party', label: 'External party' }
]

export const RESOLUTION_OPTIONS = [
  { value: 'resolved', label: 'Resolved' },
  { value: 'deferred', label: 'Deferred / Technical debt' },
  { value: 'cannot_resolve', label: 'Cannot resolve' },
  { value: 'not_reproduced', label: 'Not reproduced' },
  { value: 'duplicate', label: 'Duplicate' },
  { value: 'cancelled', label: 'Cancelled' }
]

export const PRIORITY_OPTIONS = [
  { value: 'high', label: 'High', tone: 'red' },
  { value: 'medium', label: 'Medium', tone: 'amber' },
  { value: 'low', label: 'Low', tone: 'neutral' }
]

export function statusOption(value) {
  return STATUS_OPTIONS.find(option => option.value === value) || STATUS_OPTIONS[0]
}

export function statusLabel(value) {
  return statusOption(value).label
}

export function statusTone(value) {
  return statusOption(value).tone
}

export function priorityOption(value) {
  return PRIORITY_OPTIONS.find(option => option.value === value) || PRIORITY_OPTIONS[1]
}

export function priorityLabel(value) {
  return priorityOption(value).label
}

export function priorityTone(value) {
  return priorityOption(value).tone
}

export function waitingLabel(value) {
  return WAITING_OPTIONS.find(option => option.value === value)?.label || ''
}

export function resolutionLabel(value) {
  return RESOLUTION_OPTIONS.find(option => option.value === value)?.label || ''
}

export function apiError(error, fallback = 'The request could not be completed.') {
  const data = error?.response?.data
  return data?.details || data?.detail || fallback
}

export function isStaleTicketError(error) {
  return error?.response?.status === 400
    && error?.response?.data?.details === 'This ticket changed in another session. Refresh and try again.'
}

export function idempotencyKey() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID()
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export function normalizePage(data) {
  return Array.isArray(data) ? data : (data?.results || [])
}

export function formatDateTime(value) {
  if (!value) return '—'
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
  }).format(new Date(value))
}

export function relativeTime(value) {
  if (!value) return ''
  const seconds = Math.max(0, Math.round((Date.now() - new Date(value).getTime()) / 1000))
  if (seconds < 60) return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 48) return `${hours}h ago`
  return `${Math.floor(hours / 24)}d ago`
}
